// Per-apartment SEO data – used for /wohnung/:slug routes.
// Each entry has DE + EN versions of <title>, description, OG, Twitter.
// `canonical` and `ogImage` are language-agnostic.

const SITE = "https://neubau-kaufen-wiesbaden.de";

export const APARTMENT_SEO = {
    erdgeschoss: {
        slug: "erdgeschoss",
        apartmentId: "erdgeschoss",
        canonical: `${SITE}/wohnung/erdgeschoss`,
        ogImage: `${SITE}/og-erdgeschoss.jpg`,
        de: {
            title:
                "3-Zimmer Erdgeschosswohnung Wiesbaden-Biebrich · 78,75 m² · ab 472.000 € · G21 Neubau",
            description:
                "Barrierefreie 3-Zimmer-Eigentumswohnung im Erdgeschoss · Gaugasse 21, Wiesbaden-Biebrich · 78,75 m² · Terrasse, Kellerraum, eigener Carport · Effizienzhaus 40, KfW-förderfähig · ab 472.000 €.",
            ogTitle:
                "Erdgeschosswohnung G21 Wiesbaden · 3-Zimmer barrierefrei · ab 472.000 €",
            ogDescription:
                "Neubau Wiesbaden-Biebrich · 78,75 m² mit Terrasse · barrierefreier Zugang · Effizienzhaus 40 · Kauf direkt vom Bauträger.",
            twitterTitle:
                "Erdgeschosswohnung G21 Wiesbaden · 3 Zimmer · barrierefrei",
            twitterDescription:
                "78,75 m² · Terrasse · Carport · Effizienzhaus 40 · ab 472.000 €. Direkt vom Bauträger.",
        },
        en: {
            title:
                "3-Room ground-floor apartment Wiesbaden-Biebrich · 78.75 sqm · from €472,000 · G21 new build",
            description:
                "Barrier-free 3-room ground-floor condominium · Gaugasse 21, Wiesbaden-Biebrich · 78.75 sqm · terrace, storage, private carport · energy class 40 (Effizienzhaus 40), KfW-eligible · from €472,000.",
            ogTitle:
                "Ground-floor apartment G21 Wiesbaden · barrier-free · from €472,000",
            ogDescription:
                "New build in Wiesbaden-Biebrich · 78.75 sqm with terrace · step-free access · energy class 40 · direct from the developer.",
            twitterTitle:
                "Ground-floor apartment G21 Wiesbaden · 3 rooms · barrier-free",
            twitterDescription:
                "78.75 sqm · terrace · carport · energy class 40 · from €472,000. Direct from the developer.",
        },
    },
    obergeschoss: {
        slug: "obergeschoss",
        apartmentId: "obergeschoss",
        canonical: `${SITE}/wohnung/obergeschoss`,
        ogImage: `${SITE}/og-obergeschoss.jpg`,
        de: {
            title:
                "4-Zimmer Obergeschosswohnung Wiesbaden-Biebrich · 116,86 m² · ab 783.000 € · G21 Neubau",
            description:
                "Familienfreundliche 4-Zimmer-Eigentumswohnung im Obergeschoss · Gaugasse 21, Wiesbaden-Biebrich · 116,86 m² · Balkon, zwei Bäder, Kellerraum, Carport · Effizienzhaus 40, KfW-förderfähig · ab 783.000 €.",
            ogTitle:
                "Obergeschosswohnung G21 Wiesbaden · 4 Zimmer für Familien · ab 783.000 €",
            ogDescription:
                "Neubau Wiesbaden-Biebrich · 116,86 m² · 2 Bäder · Balkon · Carport · Effizienzhaus 40, KfW-förderfähig · direkt vom Bauträger.",
            twitterTitle:
                "Obergeschosswohnung G21 Wiesbaden · 4 Zimmer · Familien-Highlight",
            twitterDescription:
                "116,86 m² · 2 Bäder · Balkon · Carport · Effizienzhaus 40 · ab 783.000 €.",
        },
        en: {
            title:
                "4-Room upper-floor apartment Wiesbaden-Biebrich · 116.86 sqm · from €783,000 · G21 new build",
            description:
                "Family-friendly 4-room upper-floor condominium · Gaugasse 21, Wiesbaden-Biebrich · 116.86 sqm · balcony, two bathrooms, storage, carport · energy class 40, KfW-eligible · from €783,000.",
            ogTitle:
                "Upper-floor apartment G21 Wiesbaden · 4 rooms for families · from €783,000",
            ogDescription:
                "New build Wiesbaden-Biebrich · 116.86 sqm · 2 bathrooms · balcony · carport · energy class 40 · direct from the developer.",
            twitterTitle:
                "Upper-floor apartment G21 Wiesbaden · 4 rooms · family highlight",
            twitterDescription:
                "116.86 sqm · 2 bathrooms · balcony · carport · energy class 40 · from €783,000.",
        },
    },
    penthouse: {
        slug: "penthouse",
        apartmentId: "penthouse",
        canonical: `${SITE}/wohnung/penthouse`,
        ogImage: `${SITE}/og-penthouse.jpg`,
        de: {
            title:
                "Penthouse Wiesbaden-Biebrich kaufen · 114 m² mit 18 m² Dachterrasse · ab 823.000 € · G21 Neubau",
            description:
                "Penthouse-Eigentumswohnung im Dachgeschoss · Gaugasse 21, Wiesbaden-Biebrich · 114,27 m² · 18 m² Dachterrasse · 3 Zimmer · optionaler Kaminanschluss · Effizienzhaus 40, KfW-förderfähig · ab 823.000 €.",
            ogTitle:
                "Penthouse G21 Wiesbaden · 18 m² Dachterrasse · ab 823.000 €",
            ogDescription:
                "Neubau-Penthouse Wiesbaden-Biebrich · 114 m² · großzügige Dachterrasse · optionaler Kaminanschluss · Effizienzhaus 40 · direkt vom Bauträger.",
            twitterTitle:
                "Penthouse G21 Wiesbaden · 18 m² Dachterrasse · ab 823.000 €",
            twitterDescription:
                "114 m² · Dachterrasse · 3 Zimmer · optionaler Kaminanschluss · Effizienzhaus 40.",
        },
        en: {
            title:
                "Buy a penthouse in Wiesbaden-Biebrich · 114 sqm with 18 sqm roof terrace · from €823,000 · G21 new build",
            description:
                "Penthouse condominium on the top floor · Gaugasse 21, Wiesbaden-Biebrich · 114.27 sqm · 18 sqm roof terrace · 3 rooms · optional fireplace connection · energy class 40, KfW-eligible · from €823,000.",
            ogTitle:
                "Penthouse G21 Wiesbaden · 18 sqm roof terrace · from €823,000",
            ogDescription:
                "New-build penthouse Wiesbaden-Biebrich · 114 sqm · spacious roof terrace · optional fireplace · energy class 40 · direct from the developer.",
            twitterTitle:
                "Penthouse G21 Wiesbaden · 18 sqm roof terrace · from €823,000",
            twitterDescription:
                "114 sqm · roof terrace · 3 rooms · optional fireplace · energy class 40.",
        },
    },
    loft: {
        slug: "loft",
        apartmentId: "loft-maisonette",
        canonical: `${SITE}/wohnung/loft`,
        ogImage: `${SITE}/og-loft.jpg`,
        de: {
            title:
                "Loft-Maisonette Wiesbaden-Biebrich · Hinterhaus · 116 m² · ab 723.000 € · G21 Neubau",
            description:
                "Maisonette-Loft im Hinterhaus · Gaugasse 21, Wiesbaden-Biebrich · 116,62 m² · 4 Zimmer · Loggia + private Dachterrasse · ruhige Innenhof-Lage · Effizienzhaus 40, KfW-förderfähig · ab 723.000 €.",
            ogTitle:
                "Loft-Maisonette G21 Wiesbaden · Hinterhaus mit Dachterrasse · ab 723.000 €",
            ogDescription:
                "Maisonette über zwei Ebenen · 116 m² · Loggia + Dachterrasse · Loft-Charakter im ruhigen Innenhof · Effizienzhaus 40, direkt vom Bauträger.",
            twitterTitle:
                "Loft-Maisonette G21 Wiesbaden · Hinterhaus · ab 723.000 €",
            twitterDescription:
                "Maisonette · 116 m² · Loggia + Dachterrasse · Loft-Charakter · Effizienzhaus 40.",
        },
        en: {
            title:
                "Loft maisonette Wiesbaden-Biebrich · rear building · 116 sqm · from €723,000 · G21 new build",
            description:
                "Maisonette loft in the rear building · Gaugasse 21, Wiesbaden-Biebrich · 116.62 sqm · 4 rooms · loggia + private roof terrace · quiet courtyard · energy class 40, KfW-eligible · from €723,000.",
            ogTitle:
                "Loft maisonette G21 Wiesbaden · rear building with roof terrace · from €723,000",
            ogDescription:
                "Maisonette over two levels · 116 sqm · loggia + roof terrace · loft character in a quiet courtyard · energy class 40 · direct from the developer.",
            twitterTitle:
                "Loft maisonette G21 Wiesbaden · rear building · from €723,000",
            twitterDescription:
                "Maisonette · 116 sqm · loggia + roof terrace · loft character · energy class 40.",
        },
    },
};

export const DEFAULT_SEO = {
    canonical: `${SITE}/`,
    ogImage: `${SITE}/og-cover.jpg`,
    de: {
        title:
            "Eigentumswohnung Wiesbaden-Biebrich kaufen · G21 Neubau · 4 Wohnungen Effizienzhaus 40",
        description:
            "G21 – Neubau Wiesbaden-Biebrich, Gaugasse 21. 4 Eigentumswohnungen direkt vom Bauträger kaufen: 3-Zimmer EG (78 m²), 4-Zimmer OG (117 m²), Penthouse mit 18 m² Dachterrasse, Loft-Maisonette. Effizienzhaus 40, KfW-förderfähig, eigene Wärmepumpe, Carport.",
        ogTitle:
            "G21 Wiesbaden-Biebrich · 4 Eigentumswohnungen kaufen, Neubau Effizienzhaus 40",
        ogDescription:
            "Modernes Wohnensemble mit 4 hochwertigen Eigentumswohnungen direkt vom Bauträger. Effizienzhaus 40, KfW-förderfähig, eigene Wärmepumpe, Carport, Innenhof. Verkauf läuft.",
        twitterTitle:
            "G21 Wiesbaden-Biebrich · 4 Eigentumswohnungen, Effizienzhaus 40",
        twitterDescription:
            "Modernes Wohnensemble · 3-Zimmer ab 472.000 € · Penthouse mit Dachterrasse · KfW-förderfähig · Direktverkauf vom Bauträger.",
    },
    en: {
        title:
            "Buy a condominium in Wiesbaden-Biebrich · G21 new build · 4 apartments, energy class 40",
        description:
            "G21 – new build in Wiesbaden-Biebrich, Gaugasse 21. 4 condominiums direct from the developer: 3-room ground floor (78 sqm), 4-room upper floor (117 sqm), penthouse with 18 sqm roof terrace, loft maisonette. Energy class 40, KfW-eligible, own heat pump, carport.",
        ogTitle:
            "G21 Wiesbaden-Biebrich · 4 condominiums for sale, new build, energy class 40",
        ogDescription:
            "Modern residential ensemble with 4 high-quality condominiums direct from the developer. Energy class 40, KfW-eligible, own heat pump, carport, courtyard. Sales open.",
        twitterTitle:
            "G21 Wiesbaden-Biebrich · 4 condominiums, energy class 40",
        twitterDescription:
            "Modern residential ensemble · 3-room from €472,000 · penthouse with roof terrace · KfW-eligible · direct from the developer.",
    },
};

/**
 * Per-route SEO for the main navigation pages – unique title, description
 * and canonical per page (avoids duplicate-title/canonical issues).
 */
export const PAGE_SEO = {
    wohnungen: {
        canonical: `${SITE}/wohnungen`,
        ogImage: `${SITE}/og-cover.jpg`,
        de: {
            title:
                "4 Neubau-Wohnungen im Vergleich · Grundrisse & Preise · G21 Wiesbaden-Biebrich",
            description:
                "Alle 4 Eigentumswohnungen im Überblick: Grundrisse, Wohnflächen, Preise & Verfügbarkeit. 3-Zi.-EG mit Terrasse, 4-Zi.-OG mit Balkon, Penthouse mit Dachterrasse, Loft-Maisonette. Direkt vom Bauträger, Effizienzhaus 40.",
        },
        en: {
            title:
                "4 new-build apartments compared · floor plans & prices · G21 Wiesbaden-Biebrich",
            description:
                "All 4 condominiums at a glance: floor plans, living areas, prices & availability. 3-room ground floor with terrace, 4-room upper floor with balcony, penthouse with roof terrace, loft maisonette. Direct from the developer, energy class 40.",
        },
    },
    architektur: {
        canonical: `${SITE}/architektur`,
        ogImage: `${SITE}/og-cover.jpg`,
        de: {
            title:
                "Architektur & Energiekonzept · Effizienzhaus 40 · G21 Neubau Wiesbaden-Biebrich",
            description:
                "Effizienzhaus 40 mit eigener Wärmepumpe je Wohnung, 2 kW Photovoltaik-Anlage inkl. Speicher pro Einheit, KfW-förderfähig. Architektur, Bauqualität, Lage und Energiekonzept des G21 Neubaus in Wiesbaden-Biebrich.",
        },
        en: {
            title:
                "Architecture & energy concept · energy class 40 · G21 new build Wiesbaden-Biebrich",
            description:
                "Energy class 40 with an own heat pump per apartment, 2 kW photovoltaic system incl. storage per unit, KfW-eligible. Architecture, build quality, location and energy concept of the G21 new build in Wiesbaden-Biebrich.",
        },
    },
    kontakt: {
        canonical: `${SITE}/kontakt`,
        ogImage: `${SITE}/og-cover.jpg`,
        de: {
            title:
                "Kontakt & Besichtigung · Exposé anfordern · G21 Neubau Wiesbaden-Biebrich",
            description:
                "Jetzt unverbindlich anfragen: Exposé als PDF erhalten, Termin am Bauplatz vereinbaren oder Wunsch-Wohnung reservieren. Direkter Kontakt zum Bauträger des G21 Projekts in Wiesbaden-Biebrich – ohne Makler.",
        },
        en: {
            title:
                "Contact & viewing · request the exposé · G21 new build Wiesbaden-Biebrich",
            description:
                "Get in touch without obligation: receive the PDF exposé, arrange an on-site appointment or reserve your preferred apartment. Direct contact with the developer of the G21 project in Wiesbaden-Biebrich – no broker.",
        },
    },
};

/**
 * Picks the right language variant for a SEO entry. Returns a flat object
 * suitable for SeoHead.
 */
export const resolveSeo = (entry, lang) => {
    if (!entry) return null;
    const l = entry[lang] || entry.de || entry.en || {};
    return {
        title: l.title,
        description: l.description,
        ogTitle: l.ogTitle,
        ogDescription: l.ogDescription,
        twitterTitle: l.twitterTitle,
        twitterDescription: l.twitterDescription,
        ogImage: entry.ogImage,
        canonical: entry.canonical,
        lang,
    };
};
